export const SITE_ORIGIN = "https://pilates-instructor.com";

export const HOME_TITLE =
	"Balanced Body®ピラティスインストラクター養成講座 - 世界で通用する資格取得";

export const SITE_TITLE_PREFIX =
	"Balanced Body®ピラティスインストラクター資格取得養成講座";

export const DEFAULT_DESCRIPTION =
	"本校で指導資格が取得できるBalanced Bodyのピラティスインストラクター養成講座は、基礎解剖学と運動学の学習から始まります。せっかく学ぶならきちんとした知識をもったピラティスインストラクターに。本校では対面での受講だけではなく、完全オンラインでも世界に通用するピラティスインストラクター資格が取得できます。";

export function buildPageTitle(pageTitle?: string): string {
	if (!pageTitle) return HOME_TITLE;
	return `${SITE_TITLE_PREFIX} | ${pageTitle}`;
}

export function buildCanonical(pathname: string): string {
	const normalized = pathname.endsWith("/") ? pathname : `${pathname}/`;
	return `${SITE_ORIGIN}${normalized}`;
}
